import {Navigate} from 'react-router-dom';
import {useAppContext} from '../context/app-context';
import FullPageLoader from './full-page-loader';

type Props = {
    children: React.ReactNode;
};

/**
 * Routing only — the session itself is resolved once by AppProvider. This gate
 * reads the outcome, so navigating between pages costs no `/user` requests.
 */
export default function AuthGate({children}: Props) {
    const {authStatus} = useAppContext();

    if (authStatus === 'validating') {
        return <FullPageLoader/>;
    }

    if (authStatus === 'forbidden') {
        return <Navigate to="/unauthorized?reason=permission_denied" replace/>;
    }

    if (authStatus === 'no_session') {
        return <Navigate to="/unauthorized?reason=no_session" replace/>;
    }

    return <>{children}</>;
}
